import { Link } from "gatsby";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Rapidfreeservices() {
  return (
    <section
      className="rapid_free_services p-100"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={11} lg={9} className="m-auto text-center">
            <h3 className="h3_head">
              Our Generative <span>AI Implementation Process</span>
            </h3>
            <p>
              Our Generative AI solutions help businesses navigate through
              modern data capitalization challenges. Our extensive workflow
              makes this possible with guaranteed top-tier results and
              consistent growth.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="rapid_box h-100 mb-0">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                01
              </div>
              <div className="rapid_content">
                <h5>
                  Comprehensive Data <br className="d-md-block d-none" />
                  Collection & Preparation
                </h5>
                <p>
                  Thoroughly clean, preprocess, and structure datasets to
                  optimize them for robust generative AI model training.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="rapid_box h-100 mb-0">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                02
              </div>
              <div className="rapid_content">
                <h5>
                  Precision-Driven Model <br className="d-md-block d-none" />
                  Development
                </h5>
                <p>
                  Design and implement generative models tailored to your
                  specific use cases using advanced algorithms.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="rapid_box h-100 mb-0">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                03
              </div>
              <div className="rapid_content">
                <h5>User-Centric Interface Design</h5>
                <p>
                  Develop intuitive interfaces that enhance user interaction
                  with AI-generated content, prioritizing ease of use and
                  accessibility.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="rapid_box h-100 mb-0">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                04
              </div>
              <div className="rapid_content">
                <h5>
                  Rigorous Model Testing & <br className="d-md-block d-none" />
                  Optimization
                </h5>
                <p>
                  Iteratively test and fine-tune AI models to ensure they meet
                  precise requirements and exceed performance benchmarks.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-lg-0 mb-4">
            <div className="rapid_box h-100 mb-0">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                05
              </div>
              <div className="rapid_content">
                <h5>
                  High-Volume Scalability <br className="d-md-block d-none" />
                  Solutions
                </h5>
                <p>
                  Deploy scalable infrastructures that manage computational
                  demands, ensuring seamless operation as data volumes expand.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-md-0 mb-4">
            <div className="rapid_box h-100 mb-0">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                06
              </div>
              <div className="rapid_content">
                <h5>Seamless AI Integration</h5>
                <p>
                  Integrate generative AI seamlessly into your existing tech
                  stack with custom APIs for efficient AI-driven output
                  handling.
                </p>
              </div>
            </div>
          </Col>
          <Row className="text-center mt-3 mt-md-4">
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Discuss Your Gen AI Project
              </Link>
            </Col>
          </Row>
        </Row>
      </Container>
    </section>
  );
}

export default Rapidfreeservices;
